import React, { useEffect } from 'react';
import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import InBoundCallimg from '../../../../Assets/Image/InboudCall.svg';
import { AppColors } from '../../../../Utils/helper/AppColors';
import { useNavigate, useParams } from 'react-router-dom';
import CultService from '../../../../Services/CultService';

export const StartYourCall = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const EXP_TIME_KEY = 'navSettingsExpTime';
	const EXPIRATION_MS = 2 * 60 * 60 * 1000;

	const fetchAssistants = async () => {
		try {
			const now = new Date().getTime();
			const expTime = localStorage.getItem(EXP_TIME_KEY);

			if (expTime && now < Number(expTime)) {
				// Not expired, skip API call
				console.log('Using cached navSettings, not calling API');
				window.dispatchEvent(new Event('navSettingsChanged'));
				return;
			}

			const response = await CultService.getIncomingCallAssistants({ params: { companyId: id } });

			console.log('Fetch assistants response:', response);
			if (response?.data?.success) {
				localStorage.setItem('navSettings', JSON.stringify(response?.data?.data?.companyNavigation));
				localStorage.setItem(EXP_TIME_KEY, now + EXPIRATION_MS); // Set new expiration time
				window.dispatchEvent(new Event('navSettingsChanged'));
			}
		} catch (error) {
			console.error('Error fetching assistants:', error);
			// toast.error('Something Went Wrong Please try again later');
		}
	};

	useEffect(() => {
		if (id) {
			fetchAssistants();
		}
	}, [id]);

	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				bgcolor: '#F5F6FA',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				px: 2,
			}}
		>
			{/* Background image overlay */}
			<Box
				sx={{
					position: 'absolute',
					inset: 0,
					width: '100%',
					height: '100%',
					backgroundImage: `url(${InBoundCallimg})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					opacity: 0.5, // Adjust for desired effect
					zIndex: 0,
				}}
			/>

			{/* Main Content */}
			<Stack spacing={5} alignItems="center" sx={{ width: '100%', maxWidth: 800, mx: 'auto', mb: 4, zIndex: 1 }}>
				<Typography
					sx={{
						fontWeight: 700,
						fontSize: { xs: '28px', md: '42px' }, // Increase with screen size
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: 0,
						textAlign: 'center',
						color: AppColors?.BLACK,
					}}
				>
					Share Your Thoughts Confidentially with Our HR AI Agent
				</Typography>
				<Typography
					sx={{
						fontWeight: 400,
						fontStyle: 'normal',
						fontSize: '16px',
						lineHeight: '150%',
						letterSpacing: 0,
						textAlign: 'center',
						color: AppColors?.BLACK,
					}}
				>
					Speak freely and securely with our AI-powered HR agent. Share feedback, concerns, or thoughts anytime—judgment-free and fully confidential. We're here to listen and support you.
				</Typography>
			</Stack>

			<Button
				variant="contained"
				color="info"
				sx={{ borderRadius: '21px', width: '130px', fontSize: '12px', fontWeight: 600 }}
				onClick={() => navigate('call')}
			>
				Start Now
			</Button>
		</Box>
	);
};
